import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcaseOnWheelsWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 7V2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5.79q0 .053-.005.105Q14 7.948 14 8c0 .55-.45 1-1 1H6.66a.66.66 0 0 0-.66.66v8.69c0 .36.29.66.66.66h8.68c.36 0 .66-.29.66-.66v-5.36c0-.55.45-1 1-1s1 .45 1 1v5.36c0 1.46-1.19 2.66-2.66 2.66V21H15v1c0 .55-.45 1-1 1s-1-.45-1-1v-1H9v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-.34C5.2 21 4 19.81 4 18.34V9.66C4 8.2 5.19 7 6.66 7zm4 0V3h-2v4z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11 17h-.01c-.33 0-.64-.17-.82-.45l-2-3a1.001 1.001 0 1 1 1.67-1.11l1.19 1.78 6.15-8.79c.32-.45.94-.56 1.39-.25s.56.94.25 1.39l-7 10c-.19.27-.49.43-.82.43"
    />
  </svg>
);
export default SvgSuitcaseOnWheelsWithCheckMark;
